<script>
import { ContractSignatureError } from '../../../../Errors/ContractSignatureError'

export default {
  props: {
    error: {
      type: ContractSignatureError,
      required: true,
    },
  },
  computed: {
    alertClass() {
      return {
        alert: true,
        'alert-warning': ['esign.cancelled', 'esign.missingValidation', 'esign.notFound'].includes(this.error.code),
        'alert-danger': ['esign.error', 'esign.environmentMismatch'].includes(this.error.code),
        'alert-success': 'esign.alreadySigned' === this.error.code,
        'text-center': true,
      }
    },
  },
}
</script>
<template>
  <div :class="alertClass">
    <div><strong v-html="error.message"></strong></div>
    <slot />
  </div>
</template>
